import React, { useState } from 'react';
import * as S from './NameUpdate.styles';

const NameUpdate = ({closePop, errorMessage, submitName}) => {
    const [fullName, setFullName] = useState('');

    const onNameChange = (event) => {
        // Validate full name for only alphabets and spaces
        const re = /^[a-zA-Z\s]+$/;
        if (event.target.value !== '' && !re.test(event.target.value)) {
            return;
        }
        setFullName(event.target.value);
    }

    const onSubmit = (event) => {
        event.preventDefault();
        submitName({full_name: fullName?.trim()});
    }

    return (
        <S.NameUpdatePop>
            <S.NameUpdatePopContent>
                <S.NameUpdatePopHeader>
                    <S.PopBackBtn onClick={closePop}>Close</S.PopBackBtn>
                    <S.HeaderText>Update Full Name</S.HeaderText>
                </S.NameUpdatePopHeader>
                <S.ModalBody>
                    <S.NameInputLabel type="text" htmlFor="fullName">Enter Full Name</S.NameInputLabel>
                    <S.NameInput type="text" placeholder="Full Name" id="fullName" name="fullName" value={fullName} onChange={onNameChange} />
                    {errorMessage && <S.ErrorMessage>{errorMessage}</S.ErrorMessage>}
                    <S.SubmitBtn type="submit" disabled={!fullName} onClick={onSubmit}>Update</S.SubmitBtn>
                </S.ModalBody>
            </S.NameUpdatePopContent>
        </S.NameUpdatePop>
    )
}

export default NameUpdate;